import { useSubmitAssessment } from "@/api/app/assessment/useSubmitAssessment";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import toast from "@/lib/toast";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface SubmitButtonProps {
  disabled: boolean;
}

function SubmitButton({ disabled }: SubmitButtonProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { trigger, isMutating } = useSubmitAssessment();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button isLoading={isMutating} disabled={disabled}>
          {t("submit-assessment")}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("warning")}</DialogTitle>
        </DialogHeader>
        <div className="grid w-full gap-2 p-4">
          <div>{t("submit-warning-message")}</div>
          <Button
            onClick={() => {
              setOpen(false);
              toast.loading(t("submit-assessment-loading"));
              trigger();
            }}
          >
            {t("submit-assessment")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SubmitButton;
